import {Route, Routes, Outlet} from 'react-router-dom'
import ListWrapper from './list/ListWrapper'
import OpListWrapper from './operations/ListWrapper'
import BulkOrderWrapper from './orders/BulkOrderWrapper'

const SuppliersPage = () => (
  <Routes>
    <Route element={<Outlet />}>
      <Route path='/list' element={<ListWrapper />} />
      <Route path='/operations' element={<OpListWrapper />} />
      <Route path='/bulk-order' element={<BulkOrderWrapper />} />
      <Route path='/bulk-order/:id' element={<BulkOrderWrapper />} />
    </Route>
  </Routes>
)


export default SuppliersPage
